import React, { useState } from 'react';
import { useProjectModel } from '../../../model.js';
import { generateDashboardModal } from './generate.js';
import { useGenerationTask } from '../hooks/use-generation-task.js';
import { ChooseFolderStep, ChooseTitleStep } from './steps.js';
import {
  CompleteGeneration,
  CompleteGenerationMessage,
} from '../CompleteGeneration.js';

export const useGenerateDashboardModal = () => {
  const { model } = useProjectModel();

  const [modalFolder, setModalFolder] = useState<string>();
  const [modalTitle, setModalTitle] = useState<string>();

  const modalQuestionsAnswered = modalFolder && modalTitle;

  const generationTask = useGenerationTask(async () => {
    if (!modalQuestionsAnswered) {
      return;
    }

    return generateDashboardModal(model.projectFolder, modalFolder, modalTitle);
  }, [modalQuestionsAnswered]);

  return [
    <ChooseTitleStep onSubmit={setModalTitle} />,
    <ChooseFolderStep
      onSubmit={setModalFolder}
      modalTitle={modalTitle}
      modalFolder={modalFolder}
    />,
    <CompleteGeneration
      generationTask={generationTask}
      extensionType={'dashboard modal'}
      successMessage={CompleteGenerationMessage.SuccessMessage({
        learnMoreUrl: 'https://dev.wix.com/docs/go-headless',
      })}
      route={modalFolder}
    />,
  ];
};
